import React from 'react';
import {
  EmptyPageWrapper,
  EmptyPageHeading,
  EmptyPageMessage,
} from './EmptyOnboarding.styles';

type IEmptyFile = {
  title: string;
  message: string;
};
const EmptyOnboarding = ({ title, message }: IEmptyFile) => {
  return (
    <EmptyPageWrapper>
      <EmptyPageHeading>{title}</EmptyPageHeading>
      {message && <EmptyPageMessage>{message} </EmptyPageMessage>}
    </EmptyPageWrapper>
  );
};

export { EmptyOnboarding };
